import { useState, useEffect, Fragment } from "react";
import apiRequest from "../../Api";
import BasicTable from "../../components/VirtuosoTable";
import ReactToast from "../../components/Toast";
import SearchBar from "../../components/SearchBar";
function PurchaseListing(props) {
  const [purchaseList, setPurchaseList] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (isLoading) {
      CallAPiList();
    }
  }, [purchaseList]);

  const onSearch = (event) => {
    let searchterm = event.target.value;

    if (searchterm) {
      const newItems = purchaseList.filter((row, index) => {
        return (
          row.invoice_no
            .toLowerCase()
            .includes(searchterm.toLowerCase()) ||
          row.invoice_date.toLowerCase().includes(searchterm.toLowerCase()) ||
          row.net_amount
            .toLowerCase()
            .includes(searchterm.toLowerCase()) ||
          row.item_qty
            .toLowerCase()
            .includes(searchterm.toLowerCase().toString())
        );
      });
      setFilterData(newItems);
    } else {
      setFilterData(purchaseList);
    }
  };

  let headerData = [
    {
      label: "Invoice No",
      render: (data) => data.invoice_no,
      className: "text-left",
      addLink: "yes",
      urlLink: "purchase-detail/",
      renderLink: (data) => data.master_id,
    },
    {
      label: "Invoice Date",
      render: (data) => data.invoice_date,
      className: "text-left",
    },
    {
      label: "Qty",
      render: (data) => data.item_qty,
      className: "text-center",
    },
    
    {
      label: "Net Amount",
      render: (data) => data.net_amount,
      className: "text-right",
    },
  ];

  const CallAPiList = async () => {
    try {
      const url = process.env.REACT_APP_API_BASE;
      let apiSetting = {
        method: "POST",
        apiParams: {
          // p_party_id: "5",
        },
      };
      let listingData = await apiRequest(
        `${url}OrderPanelApi/purchaseListing`,
        apiSetting
      );
      if (listingData?.data && listingData?.data?.success == 1) {
        console.log(listingData);
        setPurchaseList(listingData?.data.data);
        setFilterData(listingData?.data?.data);
      } else {
        throw new Error(listingData?.data?.message);
      }
    } catch (error) {
      ReactToast({ type: "error", message: error.message });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <h5>My Purchases</h5>
      <SearchBar onSearch={onSearch} />
      <BasicTable headers={headerData} data={filterData} />
    </Fragment>
  );
}

export default PurchaseListing;
